import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { Route, Switch } from 'react-router-dom'

import config from '../config.js'
import { IEstablishment } from '../Establishment/interface/IEstablishment'
import { PublicEstablishmentStats } from '../EstablishmentStats/public'
import { IUser } from '../User/DataStore/IUser'
import Login from '../User/Login/Login'
import Signup from '../User/Signup/Signup'

import useLocalStorage from './Hooks/useLocalStorage'
import { PrivateRoutes } from './PrivateRoutes'

export const AppRoutes = () => {
  const establishmentData = useLocalStorage<null | IEstablishment>(
    'login_establishment',
    null,
  )
  const userData = useLocalStorage<IUser | null>('login_user', null)

  return (
    <Switch>
      <Route path="/login" component={Login} />
      <Route
        path="/:language/signup"
        render={injectedProps => (
          <GoogleReCaptchaProvider
            reCaptchaKey={config.recaptchaSiteKey}
            language="nl"
            useEnterprise>
            <Signup language={String(injectedProps.match.params.language)} />
          </GoogleReCaptchaProvider>
        )}
      />
      <Route
        path="/s/stats/:establishmentUuid"
        component={PublicEstablishmentStats}
      />
      {(!userData && !establishmentData) || <PrivateRoutes />}
    </Switch>
  )
}
